import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const relationshipsApi = {};

/*
 * Calls the data aggregation api to get relationships.
 * @returns {object} the response data
 */
relationshipsApi.getRelationships = async () => {
  // Grab all relationships from the consumer api
  // Push into an array if the name is "Healthcare Provider" or "Other"
  try {
    const response = await axios.get(`${consumerBaseUrl}/relationships`);
    let responseData = response.data;
    let filteredRelationships = { data: [] };
    responseData.data.map((relationship) => {
      if (
        relationship.name === "Healthcare Provider" ||
        relationship.name === "Other"
      ) {
        // add to filteredRelationships
        filteredRelationships.data.push(relationship);
      }
    });
    logger.info("relationships api", filteredRelationships);
    return filteredRelationships;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export default relationshipsApi;
